"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var innerFunction = react_1.default.forwardRef(function (_a, ref) {
    var row = _a.row, check = _a.check, inline = _a.inline, disabled = _a.disabled, props = __rest(_a, ["row", "check", "inline", "disabled"]);
    return react_1.default.createElement("div", __assign({ ref: ref }, props));
});
innerFunction.displayName = "innerFunction";
var FormGroup = styled_components_1.default(innerFunction)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  width: 100%;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  ", ";\n  width: 100%;\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n"])), style_utils_1.setMargin("bottom", 3), function (props) {
    return props.row && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", "\n      ", "\n      margin-right: -1.071rem;\n      margin-left: -1.071rem;\n    "], ["\n      ", "\n      ", "\n      margin-right: -1.071rem;\n      margin-left: -1.071rem;\n    "])), style_utils_1.setDisplay("flex"), style_utils_1.setWrap("wrap"));
}, function (props) {
    return props.check && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      position: relative;\n      display: block;\n      padding-left: 1.25rem;\n    "], ["\n      position: relative;\n      display: block;\n      padding-left: 1.25rem;\n    "])));
}, function (props) {
    return props.check &&
        props.inline && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      display: inline-flex;\n      align-items: center;\n      padding-left: 0;\n      margin-right: 0.75rem;\n    "], ["\n      display: inline-flex;\n      align-items: center;\n      padding-left: 0;\n      margin-right: 0.75rem;\n    "])));
});
exports.default = FormGroup;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map